import { apiGet, apiPost, apiPut } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const arStatsApi = {
  /**
   * @apiRoute GET '/stats/ar/insights/last-updated'
   */
  async getLastUpdated() {
    try {
      return await apiGet(getPath('stats/ar/insights/last-updated'));
    } catch (err) {
      await handleApiError(
        err,
        'getLastUpdated',
        true,
        'Error fetching last updated'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/ar/details'
   */
  async getDetails(payload) {
    try {
      return await apiPost(getPath('stats/ar/details'), payload);
    } catch (err) {
      await handleApiError(err, 'getDetails', true, 'Error fetching details');
    }
  },

  /**
   * @apiRoute POST '/stats/ar/insights/<type>'
   */
  async getTotalAverageInsights(payload) {
    try {
      return await apiPost(
        getPath('stats/ar/insights/total-averages'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getTotalAverageInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/ar/insights/<type>'
   */
  async getCurrentSummaryInsights(payload) {
    try {
      return await apiPost(
        getPath('stats/ar/insights/current-summary'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getCurrentSummaryInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/ar/insights/<type>'
   */
  async getHighDollarSummaryInsights(payload) {
    try {
      return await apiPost(
        getPath('stats/ar/insights/current-high-dollar-summary'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getHighDollarSummaryInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/ar/breakout/<type>'
   */
  async getTotalBreakoutChart(payload) {
    try {
      return await apiPost(
        getPath('stats/ar/breakout/total-ar-chart'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getTotalBreakoutChart',
        true,
        'Error fetching breakout chart'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/ar/breakout/<type>'
   */
  async getTotalBreakoutTable(payload) {
    try {
      return await apiPost(
        getPath('stats/ar/breakout/total-ar-table'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getTotalBreakoutTable',
        true,
        'Error fetching breakout table'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/ar/breakout/<type>'
   */
  async getHighDollarBreakoutChart(payload) {
    try {
      return await apiPost(
        getPath('stats/ar/breakout/current-high-dollar-chart'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getHighDollarBreakoutChart',
        true,
        'Error fetching breakout chart'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/ar/breakout/<type>'
   */
  async getHighDollarBreakoutTable(payload) {
    try {
      return await apiPost(
        getPath('stats/ar/breakout/current-high-dollar-table'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getHighDollarBreakoutTable',
        true,
        'Error fetching breakout table'
      );
    }
  },

  /**
   * @apiRoute GET '/stats/settings/<name>'
   */
  async getStatsSetting(name) {
    try {
      return await apiGet(getPath(`stats/settings/${name}`));
    } catch (err) {
      await handleApiError(
        err,
        'getStatsSetting',
        true,
        'Failed to load settings'
      );
    }
  },

  /**
   * @apiRoute PUT '/stats/settings/<name>'
   */
  async updateStatsSetting(name, payload) {
    try {
      return await apiPut(getPath(`stats/settings/${name}`), payload);
    } catch (err) {
      await handleApiError(
        err,
        'updateStatsSetting',
        true,
        'Failed to save settings'
      );
    }
  },
};
